export function GlobalErrorFallback() {
  return (
    <div className="flex h-screen w-full items-center justify-center text-center text-sm text-gray-500">
      Something went wrong. Please refresh the page.
    </div>
  );
}
